import { render, staticRenderFns } from "./AffWhiteList.vue?vue&type=template&id=960e4d88&scoped=true"
import script from "./AffWhiteList.vue?vue&type=script&lang=js"
export * from "./AffWhiteList.vue?vue&type=script&lang=js"
import style0 from "./AffWhiteList.vue?vue&type=style&index=0&id=960e4d88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960e4d88",
  null
  
)

export default component.exports